import PropTypes from 'prop-types';
import React from 'react';

const MoveMoneyPageHeader = ({
  showReview = true,
  headerText = 'header',
  subHeaderText = 'subheader',
  ewCurrentPage = '',
  onBackClick,
}) => {
  return (
    <div className="row">
      <div className="col-lg1-18">
        {!showReview ? (
          <div className="c-step-header move-money__header">
            <p className="c-step-header__subtext">
              Pay a bill, person or organisation or transfer money between your
              accounts. Repeating payments can be set up here too.
            </p>
          </div>
        ) : (
          <div className="c-step-header move-money__header">
            {ewCurrentPage === 'ewPaymentReason' && (
              <p className="c-step-header__crumbs">
                <a
                  className="c-step-header__link"
                  href="javascript:;"
                  onClick={onBackClick}
                >
                  <span
                    className="icon icon-page-back c-step-header__linkicon"
                    aria-hidden="true"
                    role="img"
                  />
                  <span className="c-step-header__linktext">Back</span>
                </a>
              </p>
            )}
            {ewCurrentPage === 'ewReview' && (
              <div>
                <h2 className="c-step-header__title">{headerText}</h2>
                <p className="c-step-header__subtext">{subHeaderText}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

MoveMoneyPageHeader.propTypes = {
  showReview: PropTypes.bool,
  headerText: PropTypes.string,
  subHeaderText: PropTypes.string,
  ewCurrentPage: PropTypes.string,
  onBackClick: PropTypes.func,
};

export default MoveMoneyPageHeader;
